// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// import { Typography, Button, TextField, Box, Paper, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Checkbox, FormControlLabel } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';
// import { Alert } from '@mui/material';
// import { useAuth } from '../auth/Auth';

// const SuppliersPage = () => {
//   const [contractor, setContractor] = useState(null);
//   const [contractorType, setContractorType] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [errors, setErrors] = useState({
//     syrveEdrpou: '',
//     edrpou: '',
//     name: '',
//     wynik: '',
//     ederpou_name: ''
//   });
//   const [generalError, setGeneralError] = useState('');
//   const [suppliers, setSuppliers] = useState({});
//   const [newSupplier, setNewSupplier] = useState({
//     syrveEdrpou: '',
//     edrpou: '',
//     name: '',
//     wynik: '',
//     contractorId: '',
//     status: 1,
//     ederpou_name: ''
//   });
//   const [multipleFields, setMultipleFields] = useState([{ edrpou: '', ederpou_name: '' }]);

//   const handleFieldChange = (index, field, value) => {
//     const newFields = [...multipleFields];
//     newFields[index][field] = value;
//     setMultipleFields(newFields);
//   };

//   const handleAddField = () => {
//     setMultipleFields([...multipleFields, { edrpou: '', ederpou_name: '' }]);
//   };

//   const handleRemoveField = (index) => {
//     const newFields = multipleFields.filter((_, i) => i !== index);
//     setMultipleFields(newFields);
//   };

//   const getEndpoint = () => {
//     return language === 'pl-PL' ? 'suppliers-mmm-pl' : 'suppliers-mmm';
//   };

//   const [multipleEdrpou, setMultipleEdrpou] = useState(['']);
//   const [editMode, setEditMode] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [existingSupplierMode, setExistingSupplierMode] = useState(false);
//   const [editDialogOpen, setEditDialogOpen] = useState(false);
//   const [editingSupplier, setEditingSupplier] = useState(null);
//   const { user } = useAuth();
//   const [translations, setTranslations] = useState(null);
//   const [language, setLanguage] = useState('uk-UA');
//   const [multipleEdrpouNames, setMultipleEdrpouNames] = useState(['']);
//   const [editingField, setEditingField] = useState('name');

//   useEffect(() => {
//     if (user?.user_id) {
//       fetchContractorData();
//     }
//   }, [user]);
  
//   const fetchContractorData = async () => {
//     try {
//       const userId = user?.user_id;
//       if (!userId) {
//         setGeneralError('Користувач не авторизований');
//         setLoading(false);
//         return;
//       }
  
//       const regionResponse = await axios.get(`https://bank2.daolog.net/user-region/${userId}`);
//       const userRegion = regionResponse.data.region;
//       setLanguage(userRegion);

//       // Новий ендпоінт для перекладів
//       const translationsResponse = await axios.get(`https://bank2.daolog.net/translations/suppliers/${userRegion}`);
//       setTranslations(translationsResponse.data);

//       const [contractorResponse, typeResponse, contractorDetailsResponse] = await Promise.all([
//         axios.get(`https://bank2.daolog.net/user-contractor-mmm/${userId}`),
//         axios.get(`https://bank2.daolog.net/user-contractor-type-mmm/${userId}`),
//         axios.get(`https://bank2.daolog.net/contractor-details-mmm/${userId}`)
//       ]);
  
//       const contractorData = contractorDetailsResponse.data;
//       setContractor(contractorData);
//       setContractorType(typeResponse.data.type);
//       setNewSupplier(prev => ({...prev, contractorId: contractorData.id}));
      
//       if (contractorData.id) {
//         await fetchSuppliers(contractorData.id);
//         await generateConfig(contractorData.id);
//       }
      
//       setLoading(false);
//     } catch (error) {
//       console.error('Error fetching contractor data:', error);
//       setGeneralError('Помилка при отриманні даних');
//       setLoading(false);
//     }
//   };

//   const generateConfig = async (contractorId) => {
//     try {
//       await axios.post(`https://bank2.daolog.net/generate-suppliers-config-mmm`, {
//         contractorId: contractorId
//       });
//     } catch (error) {
//       console.error('Error generating config:', error);
//       setGeneralError('Помилка при генерації конфігурації');
//     }
//   };
  
//   const fetchSuppliers = async (contractorId) => {
//     try {
//       const response = await axios.get(`https://bank2.daolog.net/suppliers-mmm/${contractorId}`);
//       const data = response.data;
      
//       const grouped = data.reduce((acc, supplier) => {
//         if (!acc[supplier.syrve_edrpou]) {
//           acc[supplier.syrve_edrpou] = [];
//         }
//         acc[supplier.syrve_edrpou].push(supplier);
//         return acc;
//       }, {});
      
//       setSuppliers(grouped);
//     } catch (error) {
//       console.error('Error fetching suppliers:', error);
//       setGeneralError(translations?.errorFetchingSuppliers || 'Помилка при отриманні постачальників');
//     }
//   };

//   const handleExistingSupplierClick = async (syrveEdrpou, name) => {
//     setExistingSupplierMode(true);
//     setNewSupplier(prev => ({
//       ...prev,
//       syrveEdrpou: syrveEdrpou,
//       name: name,
//       edrpou: ''
//     }));
//     setMultipleEdrpou(['']);
//   };

//   const handleOpenEditDialog = (supplier, field = 'name') => {
//     const supplierToEdit = { ...supplier };
    
//     if (field === 'name') {
//       supplierToEdit.edrpou = supplier.syrve_edrpou;
//     }
    
//     setEditingSupplier(supplierToEdit);
//     setEditingField(field);
//     setEditDialogOpen(true);
//   };

//   const handleCloseEditDialog = () => {
//     setEditingSupplier(null);
//     setEditingField('name');
//     setEditDialogOpen(false);
//   };

//   const handleStatusChange = async (syrveEdrpou, newStatus) => {
//     try {
//       const response = await axios.put(`https://bank2.daolog.net/suppliers/group-status-mmm/${syrveEdrpou}`, {
//         status: newStatus,
//         userId: user?.user_id,
//         contractorId: contractor?.id
//       });
      
//       if (response.data.success) {
//         await fetchSuppliers(contractor?.id);
//         await generateConfig(contractor?.id);
//       }
//     } catch (error) {
//       console.error('Error updating suppliers status:', error);
//       setGeneralError(translations?.errorUpdatingStatus || 'Помилка при оновленні статусу постачальників');
//     }
//   };

//   const handleAddEdrpou = () => {
//     setMultipleEdrpou([...multipleEdrpou, '']);
//     setMultipleEdrpouNames([...multipleEdrpouNames, '']);
//   };

//   const handleEdrpouChange = (index, value) => {
//     const newEdrpou = [...multipleEdrpou];
//     newEdrpou[index] = value;
//     setMultipleEdrpou(newEdrpou);
//   };

//   const handleRemoveEdrpou = (index) => {
//     const newEdrpou = multipleEdrpou.filter((_, i) => i !== index);
//     const newEdrpouNames = multipleEdrpouNames.filter((_, i) => i !== index);
//     setMultipleEdrpou(newEdrpou);
//     setMultipleEdrpouNames(newEdrpouNames);
//   };

//   const handleSaveEdit = async () => {
//     try {
//       const response = await axios.put(`https://bank2.daolog.net/suppliers-mmm/update/${editingSupplier.id}`, {
//         ...editingSupplier,
//         userId: user?.user_id
//       });
      
//       if (response.data.success) {
//         await fetchSuppliers(contractor?.id);
//         await generateConfig(contractor?.id);
//         handleCloseEditDialog();
//       }
//     } catch (error) {
//       console.error('Error updating supplier:', error);
//       setGeneralError(translations?.errorUpdatingSupplier || 'Помилка при оновленні постачальника');
//     }
//   };
  
//   const validateForm = () => {
//     let isValid = true;
//     const newErrors = {
//       syrveEdrpou: '',
//       edrpou: '',
//       name: '',
//       wynik: ''
//     };

//     if (!existingSupplierMode && !newSupplier.syrveEdrpou.trim()) {
//       newErrors.syrveEdrpou = translations?.warning || 'Це поле обов\'язкове';
//       isValid = false;
//     }
//     if (!existingSupplierMode && !newSupplier.name.trim()) {
//       newErrors.name = translations?.warning || 'Це поле обов\'язкове';
//       isValid = false;
//     }
//     if (multipleEdrpou.some(edrpou => !edrpou.trim())) {
//       newErrors.edrpou = translations?.warningv || 'ЄДРПОУ обов\'язкове';
//       isValid = false;
//     }
//     if (language === 'pl-PL' && !newSupplier.wynik.trim()) {
//       newErrors.wynik = translations?.warning || 'Це поле обов\'язкове';
//       isValid = false;
//     }

//     setErrors(newErrors);
//     return isValid;
//   };

//   const handleEdrpouNameChange = (index, value) => {
//     const newEdrpouNames = [...multipleEdrpouNames];
//     newEdrpouNames[index] = value;
//     setMultipleEdrpouNames(newEdrpouNames);
//   };

//   const handleAddSupplier = async () => {
//     if (!validateForm()) {
//       return;
//     }

//     try {
//       const endpoint = getEndpoint();
//       const promises = multipleEdrpou.map((edrpou, index) => 
//         axios.post(`https://bank2.daolog.net/${endpoint}`, {
//           ...newSupplier,
//           edrpou: edrpou,
//           ederpou_name: multipleEdrpouNames[index],
//           userId: user?.user_id
//         })
//       );

//       await Promise.all(promises);
      
//       setNewSupplier({
//         syrveEdrpou: '',
//         edrpou: '',
//         name: '',
//         wynik: '',
//         contractorId: contractor?.id,
//         status: 1,
//         ederpou_name: ''
//       });
//       setMultipleEdrpou(['']);
//       setMultipleEdrpouNames(['']);
//       setErrors({
//         syrveEdrpou: '',
//         edrpou: '',
//         name: '',
//         wynik: ''
//       });
//       setExistingSupplierMode(false);
//       setGeneralError('');
//       await fetchSuppliers(contractor?.id);
//       await generateConfig(contractor?.id);
//     } catch (error) {
//       const errorMessage = error.response?.data?.message || (translations?.errorAddingSupplier || 'Помилка при додаванні постачальника');
//       setGeneralError(errorMessage);
//     }
//   };

//   const handleCancelAdd = () => {
//     setNewSupplier({
//       syrveEdrpou: '',
//       edrpou: '',
//       name: '',
//       wynik: '',
//       contractorId: contractor?.id
//     });
//     setMultipleEdrpou(['']);
//     setMultipleEdrpouNames(['']);
//     setExistingSupplierMode(false);
//     setErrors({
//       syrveEdrpou: '',
//       edrpou: '',
//       name: '',
//       wynik: ''
//     });
//     setGeneralError('');
//   };

//   const handleDeleteSupplier = async (id) => {
//     try {
//       await axios.delete(`https://bank2.daolog.net/suppliers-mmm/${id}`, {
//         data: {
//           userId: user?.user_id,
//           contractorId: contractor?.id
//         }
//       });
//       await fetchSuppliers(contractor?.id);
//       await generateConfig(contractor?.id);
//     } catch (error) {
//       console.error('Error deleting supplier:', error);
//       setGeneralError(translations?.errorDeletingSupplier || 'Помилка при видаленні постачальника');
//     }
//   };

//   if (loading) return <Typography>{translations?.loading || 'Loading...'}</Typography>;
//   if (generalError) return <Typography color="error">{generalError}</Typography>;
//   if (!translations) return <Typography>{translations?.loading || 'Loading...'}</Typography>;

//   return (
//     <Box sx={{ p: 3 }} style={{ marginTop: "120px" }}>
//       <Typography variant="h6" gutterBottom>
//         <b>{translations.client}:</b> {contractor?.name}
//       </Typography>
    
//       <Typography variant="h5" gutterBottom style={{ marginTop: "20px" }}>
//         {translations.management}
//       </Typography>
      
//       <Paper sx={{ p: 2, mb: 2 }}>
//         {generalError && (
//           <Alert severity="error" sx={{ mb: 2 }}>
//             {generalError}
//           </Alert>
//         )}
//         <Box sx={{ 
//           display: 'flex', 
//           flexDirection: 'column', 
//           alignItems: 'center',
//           gap: 2 
//         }}>
//           {language === 'pl-PL' && (
//             <TextField
//               required
//               error={Boolean(errors.wynik)}
//               label={translations.wynik}
//               value={newSupplier.wynik}
//               onChange={(e) => {
//                 setNewSupplier({...newSupplier, wynik: e.target.value});
//                 setErrors({...errors, wynik: ''});
//               }}
//               disabled={existingSupplierMode}
//               helperText={errors.wynik}
//               sx={{ width: '400px' }}
//             />
//           )}
//           <TextField
//             required
//             error={Boolean(errors.syrveEdrpou)}
//             label={translations.ederpou_syrve}
//             value={newSupplier.syrveEdrpou}
//             onChange={(e) => {
//               setNewSupplier({...newSupplier, syrveEdrpou: e.target.value});
//               setErrors({...errors, syrveEdrpou: ''});
//             }}
//             disabled={existingSupplierMode}
//             helperText={errors.syrveEdrpou}
//             sx={{ width: '400px' }}
//           />
//           {multipleEdrpou.map((edrpou, index) => (
//             <Box key={index} sx={{ display: 'flex', gap: 1, alignItems: 'center', width: '400px' }}>
//             <TextField
//               required
//               error={Boolean(errors.edrpou)}
//               label={translations.edrpou}
//               value={edrpou}
//               onChange={(e) => handleEdrpouChange(index, e.target.value)}
//               helperText={index === 0 ? errors.edrpou : ''}
//               sx={{ flex: 1 }}
//             />
//             <TextField
//               required
//               label={translations.edrpouName}
//               value={multipleEdrpouNames[index]}
//               onChange={(e) => handleEdrpouNameChange(index, e.target.value)}
//               sx={{ flex: 1 }}
//             />
//             {index === multipleEdrpou.length - 1 ? (
//               <IconButton onClick={handleAddEdrpou} color="primary">
//                 <AddIcon />
//               </IconButton>
//             ) : (
//               <IconButton onClick={() => handleRemoveEdrpou(index)} color="error">
//                 <DeleteIcon />
//               </IconButton>
//             )}
//           </Box>
//           ))}
//           <TextField
//             required
//             error={Boolean(errors.name)}
//             label={translations.name_contr}
//             value={newSupplier.name}
//             onChange={(e) => {
//               setNewSupplier({...newSupplier, name: e.target.value});
//               setErrors({...errors, name: ''});
//             }}
//             disabled={existingSupplierMode}
//             helperText={errors.name}
//             sx={{ width: '400px' }}
//           />
//           <Box sx={{ display: 'flex', gap: 2 }}>
//             <Button
//               variant="contained"
//               startIcon={<AddIcon />}
//               onClick={handleAddSupplier}
//             >
//               {translations.add}
//             </Button>
//             {existingSupplierMode && (
//               <Button
//                 variant="outlined"
//                 onClick={handleCancelAdd}
//               >
//                 {translations.cancel}
//               </Button>
//             )}
//           </Box>
//         </Box>
//       </Paper>

//       <Paper sx={{ p: 2 }}>
//       {Object.entries(suppliers).map(([syrveEdrpou, supplierGroup]) => (
//   <Box key={syrveEdrpou} sx={{ mb: 2 }}>
//     <Box 
//       sx={{ 
//         p: 1, 
//         backgroundColor: 'rgba(0, 0, 0, 0.04)',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center'
//       }}
//     >
//       <Box 
//         sx={{ cursor: 'pointer' }}
//         onClick={() => handleExistingSupplierClick(syrveEdrpou, supplierGroup[0].name)}
//       >
//         <Typography><b>{translations.supplierName}:</b> {syrveEdrpou}</Typography>
//         <Typography><b>{translations.contrName}:</b> {supplierGroup[0].name}</Typography>
//       </Box>
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//         <FormControlLabel
//           control={
//             <Checkbox
//               checked={supplierGroup[0].status === 1}
//               onChange={(e) => handleStatusChange(syrveEdrpou, e.target.checked ? 1 : 0)}
//             />
//           }
//           label={supplierGroup[0].status === 1 ? translations.activeConfig : translations.inactiveConfig}
//         />
//         <IconButton onClick={() => handleOpenEditDialog(supplierGroup[0], 'name')} color="primary">
//           <EditIcon />
//         </IconButton>
//       </Box>
//     </Box>
//     <Box sx={{ pl: 2 }}>
//       {supplierGroup.map((supplier) => (
//         <Box key={supplier.id} sx={{ display: 'flex', gap: 2, mb: 1, alignItems: 'center', mt: 1 }}>
//           <Typography sx={{ flex: 1 }}>{supplier.edrpou} - {supplier.ederpou_name}</Typography>
//           <IconButton onClick={() => handleDeleteSupplier(supplier.id)} color="error">
//             <DeleteIcon />
//           </IconButton>
//           <IconButton onClick={() => handleOpenEditDialog(supplier, 'ederpou_name')} color="primary">
//             <EditIcon />
//           </IconButton>
//         </Box>
//       ))}
//     </Box>
//   </Box>
// ))}
//       </Paper>

//       <Dialog open={editDialogOpen} onClose={handleCloseEditDialog}>
//          <DialogTitle>
//           {translations.edit}
//         </DialogTitle>
//         <DialogContent>
//           <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
//             <TextField
//               label={translations.syrve_ederpou}
//               value={editingField === 'name' ? editingSupplier?.edrpou || '' : editingSupplier?.syrve_edrpou || ''}
//               onChange={(e) => setEditingSupplier({...editingSupplier, 
//                 [editingField === 'name' ? 'edrpou' : 'syrve_edrpou']: e.target.value})}
//               fullWidth
//             />
//             <TextField
//               label={translations.ederpou}
//               value={editingField === 'name' ? editingSupplier?.syrve_edrpou || '' : editingSupplier?.edrpou || ''}
//               onChange={(e) => setEditingSupplier({...editingSupplier, 
//                 [editingField === 'name' ? 'syrve_edrpou' : 'edrpou']: e.target.value})}
//               fullWidth
//             />
//             <TextField
//               label={editingField === 'name' ? translations.contrName : translations.edrpouName}
//               value={editingField === 'name' ? 
//                 (editingSupplier?.name || '') : 
//                 (editingSupplier?.ederpou_name || '')}
//               onChange={(e) => setEditingSupplier({
//                 ...editingSupplier, 
//                 [editingField]: e.target.value
//               })}
//               fullWidth
//             />
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={editingSupplier?.status === 1}
//                   onChange={(e) => setEditingSupplier({...editingSupplier, status: e.target.checked ? 1 : 0})}
//                 />
//               }
//               label={translations.activeConfig}
//             />
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseEditDialog}>{translations.cancel}</Button>
//           <Button onClick={handleSaveEdit} variant="contained">{translations.save}</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default SuppliersPage;



import React, { useState, useEffect } from 'react';
import axios from 'axios';

import {
  Typography, Button, TextField, Box, Paper, IconButton, Dialog,
  DialogTitle, DialogContent, DialogActions, Checkbox, FormControlLabel,
  Alert, Select, MenuItem, InputLabel, FormControl, Chip, Accordion,
  AccordionSummary, AccordionDetails, Tabs, Tab
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAuth } from '../auth/Auth';

const API = 'https://bank2.daolog.net';

const SuppliersPage = () => {
  const [contractor, setContractor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({
    syrveEdrpou: '', edrpou: '', name: '', wynik: ''
  });
  const [generalError, setGeneralError] = useState('');
  const [suppliers, setSuppliers] = useState({});
  const [newSupplier, setNewSupplier] = useState({
    syrveEdrpou: '', edrpou: '', name: '', wynik: '',
    contractorId: '', status: 1, ederpou_name: ''
  });

  const [multipleEdrpou, setMultipleEdrpou] = useState(['']);
  const [multipleEdrpouNames, setMultipleEdrpouNames] = useState(['']);
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [existingSupplierMode, setExistingSupplierMode] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingSupplier, setEditingSupplier] = useState(null);
  const [editingField, setEditingField] = useState('name');
  const { user } = useAuth();
  const [translations, setTranslations] = useState(null);
  const [language, setLanguage] = useState('uk-UA');

  // === Exclusions state ===
  const [exclusions, setExclusions] = useState([]);
  const [exclusionDialogOpen, setExclusionDialogOpen] = useState(false);
  const [editingExclusion, setEditingExclusion] = useState(null);
  const [newExclusion, setNewExclusion] = useState({
    name: '',
    description: '',
    keywords: [''],
    matchMode: 'startsWith',
    caseSensitive: false,
    status: '1'
  });
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (user?.user_id) fetchContractorData();
  }, [user]);

  const fetchContractorData = async () => {
    try {
      const userId = user?.user_id;
      if (!userId) {
        setGeneralError('Користувач не авторизований');
        setLoading(false);
        return;
      }

      const regionResponse = await axios.get(`${API}/user-region/${userId}`);
      const userRegion = regionResponse.data.region;
      setLanguage(userRegion);

      const translationsResponse = await axios.get(`${API}/translations/suppliers/${userRegion}`);
      setTranslations(translationsResponse.data);

      const [contractorResponse, typeResponse, contractorDetailsResponse] = await Promise.all([
        axios.get(`${API}/user-contractor-mmm/${userId}`),
        axios.get(`${API}/user-contractor-type-mmm/${userId}`),
        axios.get(`${API}/contractor-details-mmm/${userId}`)
      ]);

      const contractorData = contractorDetailsResponse.data;
      setContractor(contractorData);
      setNewSupplier(prev => ({...prev, contractorId: contractorData.id}));

      if (contractorData.id) {
        await fetchSuppliers(contractorData.id);
        await fetchExclusions(contractorData.id);
        await generateConfig(contractorData.id);
      }

      setLoading(false);
    } catch (error) {
      console.error('Error fetching contractor data:', error);
      setGeneralError('Помилка при отриманні даних');
      setLoading(false);
    }
  };

  const generateConfig = async (contractorId) => {
    try {
      await axios.post(`${API}/generate-suppliers-config-mmm`, { contractorId });
    } catch (error) {
      console.error('Error generating config:', error);
      setGeneralError('Помилка при генерації конфігурації');
    }
  };

  const fetchSuppliers = async (contractorId) => {
    try {
      const response = await axios.get(`${API}/suppliers-mmm/${contractorId}`);
      const data = response.data;
      const grouped = data.reduce((acc, supplier) => {
        if (!acc[supplier.syrve_edrpou]) acc[supplier.syrve_edrpou] = [];
        acc[supplier.syrve_edrpou].push(supplier);
        return acc;
      }, {});
      setSuppliers(grouped);
    } catch (error) {
      console.error('Error fetching suppliers:', error);
      setGeneralError(translations?.errorFetchingSuppliers || 'Помилка при отриманні постачальників');
    }
  };

  // === Exclusions API ===
  const fetchExclusions = async (contractorId) => {
    try {
      const response = await axios.get(`${API}/suppliers-exclusions-mmm/${contractorId}`);
      setExclusions(response.data || []);
    } catch (error) {
      console.error('Error fetching exclusions:', error);
      setExclusions([]);
    }
  };

  const handleOpenExclusionDialog = (exclusion = null) => {
    if (exclusion) {
      setEditingExclusion(exclusion);
      setNewExclusion({
        name: exclusion.name || '',
        description: exclusion.description || '',
        keywords: exclusion.keywords?.length ? exclusion.keywords : [''],
        matchMode: exclusion.matchMode || 'startsWith',
        caseSensitive: Boolean(exclusion.caseSensitive),
        status: exclusion.status || '1'
      });
    } else {
      setEditingExclusion(null);
      setNewExclusion({
        name: '',
        description: '',
        keywords: [''],
        matchMode: 'startsWith',
        caseSensitive: false,
        status: '1'
      });
    }
    setExclusionDialogOpen(true);
  };

  const handleCloseExclusionDialog = () => {
    setExclusionDialogOpen(false);
    setEditingExclusion(null);
  };

  const handleExclusionKeywordChange = (index, value) => {
    const newKeywords = [...newExclusion.keywords];
    newKeywords[index] = value;
    setNewExclusion({ ...newExclusion, keywords: newKeywords });
  };

  const handleAddExclusionKeyword = () => {
    setNewExclusion({ ...newExclusion, keywords: [...newExclusion.keywords, ''] });
  };

  const handleRemoveExclusionKeyword = (index) => {
    const newKeywords = newExclusion.keywords.filter((_, i) => i !== index);
    setNewExclusion({ ...newExclusion, keywords: newKeywords.length ? newKeywords : [''] });
  };

  const handleSaveExclusion = async () => {
    const cleanKeywords = newExclusion.keywords.filter(k => k && k.trim());
    if (!newExclusion.name.trim() || cleanKeywords.length === 0) {
      setGeneralError('Назва та хоча б одне ключове слово обов\'язкові');
      return;
    }

    try {
      const payload = {
        contractorId: contractor?.id,
        name: newExclusion.name,
        description: newExclusion.description,
        keywords: cleanKeywords,
        matchMode: newExclusion.matchMode,
        caseSensitive: newExclusion.caseSensitive,
        status: newExclusion.status
      };

      if (editingExclusion) {
        await axios.put(`${API}/suppliers-exclusions-mmm/${editingExclusion.id}`, payload);
      } else {
        await axios.post(`${API}/suppliers-exclusions-mmm`, payload);
      }

      await fetchExclusions(contractor?.id);
      handleCloseExclusionDialog();
    } catch (error) {
      console.error('Error saving exclusion:', error);
      setGeneralError('Помилка при збереженні виключення');
    }
  };

  const handleToggleExclusionStatus = async (exclusion) => {
    try {
      const newStatus = exclusion.status === '1' ? '0' : '1';
      await axios.put(`${API}/suppliers-exclusions-mmm/status/${exclusion.id}`, {
        contractorId: contractor?.id,
        status: newStatus
      });
      await fetchExclusions(contractor?.id);
    } catch (error) {
      console.error('Error toggling exclusion status:', error);
      setGeneralError('Помилка при зміні статусу');
    }
  };

  const handleDeleteExclusion = async (id) => {
    try {
      await axios.delete(`${API}/suppliers-exclusions-mmm/${id}`, {
        data: { contractorId: contractor?.id }
      });
      await fetchExclusions(contractor?.id);
    } catch (error) {
      console.error('Error deleting exclusion:', error);
      setGeneralError('Помилка при видаленні виключення');
    }
  };

  // === Supplier handlers ===
  const handleExistingSupplierClick = async (syrveEdrpou, name) => {
    setExistingSupplierMode(true);
    setNewSupplier(prev => ({
      ...prev, syrveEdrpou, name, edrpou: ''
    }));
    setMultipleEdrpou(['']);
    setMultipleEdrpouNames(['']);
  };

  const handleOpenEditDialog = (supplier, field = 'name') => {
    const supplierToEdit = { ...supplier };
    if (field === 'name') supplierToEdit.edrpou = supplier.syrve_edrpou;
    setEditingSupplier(supplierToEdit);
    setEditingField(field);
    setEditDialogOpen(true);
  };

  const handleCloseEditDialog = () => {
    setEditingSupplier(null);
    setEditingField('name');
    setEditDialogOpen(false);
  };

  const handleStatusChange = async (syrveEdrpou, newStatus) => {
    try {
      const response = await axios.put(`${API}/suppliers/group-status-mmm/${syrveEdrpou}`, {
        status: newStatus,
        userId: user?.user_id,
        contractorId: contractor?.id
      });
      if (response.data.success) {
        await fetchSuppliers(contractor?.id);
        await generateConfig(contractor?.id);
      }
    } catch (error) {
      console.error('Error updating suppliers status:', error);
      setGeneralError(translations?.errorUpdatingStatus || 'Помилка при оновленні статусу постачальників');
    }
  };

  const handleAddEdrpou = () => {
    setMultipleEdrpou([...multipleEdrpou, '']);
    setMultipleEdrpouNames([...multipleEdrpouNames, '']);
  };

  const handleEdrpouChange = (index, value) => {
    const newEdrpou = [...multipleEdrpou];
    newEdrpou[index] = value;
    setMultipleEdrpou(newEdrpou);
  };

  const handleEdrpouNameChange = (index, value) => {
    const newEdrpouNames = [...multipleEdrpouNames];
    newEdrpouNames[index] = value;
    setMultipleEdrpouNames(newEdrpouNames);
  };

  const handleRemoveEdrpou = (index) => {
    setMultipleEdrpou(multipleEdrpou.filter((_, i) => i !== index));
    setMultipleEdrpouNames(multipleEdrpouNames.filter((_, i) => i !== index));
  };

  const handleSaveEdit = async () => {
    try {
      const response = await axios.put(`${API}/suppliers-mmm/update/${editingSupplier.id}`, {
        ...editingSupplier,
        userId: user?.user_id
      });
      if (response.data.success) {
        await fetchSuppliers(contractor?.id);
        await generateConfig(contractor?.id);
        handleCloseEditDialog();
      }
    } catch (error) {
      console.error('Error updating supplier:', error);
      setGeneralError(translations?.errorUpdatingSupplier || 'Помилка при оновленні постачальника');
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { syrveEdrpou: '', edrpou: '', name: '', wynik: '' };

    if (!existingSupplierMode && !newSupplier.syrveEdrpou.trim()) {
      newErrors.syrveEdrpou = translations?.warning || 'Це поле обов\'язкове';
      isValid = false;
    }
    if (!existingSupplierMode && !newSupplier.name.trim()) {
      newErrors.name = translations?.warning || 'Це поле обов\'язкове';
      isValid = false;
    }
    if (multipleEdrpou.some(e => !e.trim())) {
      newErrors.edrpou = translations?.warningv || 'ЄДРПОУ обов\'язкове';
      isValid = false;
    }
    if (language === 'pl-PL' && !newSupplier.wynik.trim()) {
      newErrors.wynik = translations?.warning || 'Це поле обов\'язкове';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const getEndpoint = () => language === 'pl-PL' ? 'suppliers-mmm-pl' : 'suppliers-mmm';

  const handleAddSupplier = async () => {
    if (!validateForm()) return;
    try {
      const endpoint = getEndpoint();
      const promises = multipleEdrpou.map((edrpou, index) =>
        axios.post(`${API}/${endpoint}`, {
          ...newSupplier,
          edrpou,
          ederpou_name: multipleEdrpouNames[index],
          userId: user?.user_id
        })
      );
      await Promise.all(promises);

      setNewSupplier({
        syrveEdrpou: '', edrpou: '', name: '', wynik: '',
        contractorId: contractor?.id, status: 1, ederpou_name: ''
      });
      setMultipleEdrpou(['']);
      setMultipleEdrpouNames(['']);
      setErrors({ syrveEdrpou: '', edrpou: '', name: '', wynik: '' });
      setExistingSupplierMode(false);
      setGeneralError('');
      await fetchSuppliers(contractor?.id);
      await generateConfig(contractor?.id);
    } catch (error) {
      setGeneralError(error.response?.data?.message ||
        translations?.errorAddingSupplier || 'Помилка при додаванні постачальника');
    }
  };

  const handleCancelAdd = () => {
    setNewSupplier({
      syrveEdrpou: '', edrpou: '', name: '', wynik: '',
      contractorId: contractor?.id, status: 1, ederpou_name: ''
    });
    setMultipleEdrpou(['']);
    setMultipleEdrpouNames(['']);
    setExistingSupplierMode(false);
    setErrors({ syrveEdrpou: '', edrpou: '', name: '', wynik: '' });
    setGeneralError('');
  };

  const handleDeleteSupplier = async (id) => {
    try {
      await axios.delete(`${API}/suppliers-mmm/${id}`, {
        data: { userId: user?.user_id, contractorId: contractor?.id }
      });
      await fetchSuppliers(contractor?.id);
      await generateConfig(contractor?.id);
    } catch (error) {
      console.error('Error deleting supplier:', error);
      setGeneralError(translations?.errorDeletingSupplier || 'Помилка при видаленні постачальника');
    }
  };

  if (loading) return <Typography>{translations?.loading || 'Loading...'}</Typography>;
  if (!translations) return <Typography>Loading...</Typography>;

  return (
    <Box sx={{ p: 3 }} style={{ marginTop: '120px' }}>
      <Typography variant="h6" gutterBottom>
        <b>{translations.client}:</b> {contractor?.name}
      </Typography>

      <Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)} sx={{ mb: 2 }}>
        <Tab label={translations.management || 'Управління постачальниками'} />
        <Tab label="Виключення (не підставляти постачальника)" />
      </Tabs>

      {generalError && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setGeneralError('')}>
          {generalError}
        </Alert>
      )}

      {/* ===== TAB 0: Suppliers ===== */}
      {activeTab === 0 && (
        <>
          <Paper sx={{ p: 2, mb: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              {language === 'pl-PL' && (
                <TextField
                  required error={Boolean(errors.wynik)} label={translations.wynik}
                  value={newSupplier.wynik}
                  onChange={(e) => {
                    setNewSupplier({...newSupplier, wynik: e.target.value});
                    setErrors({...errors, wynik: ''});
                  }}
                  disabled={existingSupplierMode} helperText={errors.wynik}
                  sx={{ width: '400px' }}
                />
              )}
              <TextField
                required error={Boolean(errors.syrveEdrpou)} label={translations.ederpou_syrve}
                value={newSupplier.syrveEdrpou}
                onChange={(e) => {
                  setNewSupplier({...newSupplier, syrveEdrpou: e.target.value});
                  setErrors({...errors, syrveEdrpou: ''});
                }}
                disabled={existingSupplierMode} helperText={errors.syrveEdrpou}
                sx={{ width: '400px' }}
              />
              {multipleEdrpou.map((edrpou, index) => (
                <Box key={index} sx={{ display: 'flex', gap: 1, alignItems: 'center', width: '400px' }}>
                  <TextField
                    required error={Boolean(errors.edrpou)} label={translations.edrpou}
                    value={edrpou}
                    onChange={(e) => handleEdrpouChange(index, e.target.value)}
                    helperText={index === 0 ? errors.edrpou : ''}
                    sx={{ flex: 1 }}
                  />
                  <TextField
                    required label={translations.edrpouName}
                    value={multipleEdrpouNames[index]}
                    onChange={(e) => handleEdrpouNameChange(index, e.target.value)}
                    sx={{ flex: 1 }}
                  />
                  {index === multipleEdrpou.length - 1 ? (
                    <IconButton onClick={handleAddEdrpou} color="primary"><AddIcon /></IconButton>
                  ) : (
                    <IconButton onClick={() => handleRemoveEdrpou(index)} color="error"><DeleteIcon /></IconButton>
                  )}
                </Box>
              ))}
              <TextField
                required error={Boolean(errors.name)} label={translations.name_contr}
                value={newSupplier.name}
                onChange={(e) => {
                  setNewSupplier({...newSupplier, name: e.target.value});
                  setErrors({...errors, name: ''});
                }}
                disabled={existingSupplierMode} helperText={errors.name}
                sx={{ width: '400px' }}
              />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={handleAddSupplier}>
                  {translations.add}
                </Button>
                {existingSupplierMode && (
                  <Button variant="outlined" onClick={handleCancelAdd}>{translations.cancel}</Button>
                )}
              </Box>
            </Box>
          </Paper>

          <Paper sx={{ p: 2 }}>
            {Object.entries(suppliers).map(([syrveEdrpou, supplierGroup]) => (
              <Box key={syrveEdrpou} sx={{ mb: 2 }}>
                <Box sx={{
                  p: 1, backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                }}>
                  <Box sx={{ cursor: 'pointer' }}
                       onClick={() => handleExistingSupplierClick(syrveEdrpou, supplierGroup[0].name)}>
                    <Typography><b>{translations.supplierName}:</b> {syrveEdrpou}</Typography>
                    <Typography><b>{translations.contrName}:</b> {supplierGroup[0].name}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={supplierGroup[0].status === 1}
                          onChange={(e) => handleStatusChange(syrveEdrpou, e.target.checked ? 1 : 0)}
                        />
                      }
                      label={supplierGroup[0].status === 1 ? translations.activeConfig : translations.inactiveConfig}
                    />
                    <IconButton onClick={() => handleOpenEditDialog(supplierGroup[0], 'name')} color="primary">
                      <EditIcon />
                    </IconButton>
                  </Box>
                </Box>
                <Box sx={{ pl: 2 }}>
                  {supplierGroup.map((supplier) => (
                    <Box key={supplier.id} sx={{ display: 'flex', gap: 2, mb: 1, alignItems: 'center', mt: 1 }}>
                      <Typography sx={{ flex: 1 }}>{supplier.edrpou} - {supplier.ederpou_name}</Typography>
                      <IconButton onClick={() => handleDeleteSupplier(supplier.id)} color="error"><DeleteIcon /></IconButton>
                      <IconButton onClick={() => handleOpenEditDialog(supplier, 'ederpou_name')} color="primary"><EditIcon /></IconButton>
                    </Box>
                  ))}
                </Box>
              </Box>
            ))}
          </Paper>
        </>
      )}

      {/* ===== TAB 1: Exclusions ===== */}
      {activeTab === 1 && (
        <Paper sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">Правила виключень</Typography>
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpenExclusionDialog()}>
              Додати правило
            </Button>
          </Box>

          {exclusions.length === 0 && (
            <Typography color="text.secondary">
              Немає правил. Додайте правило, щоб для платежів з певними словами в описі не підставлявся постачальник.
            </Typography>
          )}

          {exclusions.map((exc) => (
            <Accordion key={exc.id}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                  <FormControlLabel
                    onClick={(e) => e.stopPropagation()}
                    control={
                      <Checkbox
                        checked={exc.status === '1'}
                        onChange={() => handleToggleExclusionStatus(exc)}
                      />
                    }
                    label=""
                  />
                  <Typography sx={{ flex: 1 }}>
                    <b>{exc.name}</b>
                  </Typography>
                  <Chip
                    size="small"
                    label={exc.status === '1' ? 'Активне' : 'Вимкнене'}
                    color={exc.status === '1' ? 'success' : 'default'}
                  />
                  <IconButton onClick={(e) => { e.stopPropagation(); handleOpenExclusionDialog(exc); }} color="primary">
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={(e) => { e.stopPropagation(); handleDeleteExclusion(exc.id); }} color="error">
                    <DeleteIcon />
                  </IconButton>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <b>Опис:</b> {exc.description || '—'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <b>Режим:</b> {exc.matchMode} {exc.caseSensitive ? '(чутливий до регістру)' : '(без врахування регістру)'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}><b>Ключові слова:</b></Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {exc.keywords?.map((kw, i) => <Chip key={i} label={kw} size="small" />)}
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </Paper>
      )}

      {/* ===== Edit supplier dialog ===== */}
      <Dialog open={editDialogOpen} onClose={handleCloseEditDialog}>
        <DialogTitle>{translations.edit}</DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2, minWidth: 400 }}>
            <TextField
              label={translations.syrve_ederpou}
              value={editingField === 'name' ? editingSupplier?.edrpou || '' : editingSupplier?.syrve_edrpou || ''}
              onChange={(e) => setEditingSupplier({...editingSupplier,
                [editingField === 'name' ? 'edrpou' : 'syrve_edrpou']: e.target.value})}
              fullWidth
            />
            <TextField
              label={translations.ederpou}
              value={editingField === 'name' ? editingSupplier?.syrve_edrpou || '' : editingSupplier?.edrpou || ''}
              onChange={(e) => setEditingSupplier({...editingSupplier,
                [editingField === 'name' ? 'syrve_edrpou' : 'edrpou']: e.target.value})}
              fullWidth
            />
            <TextField
              label={editingField === 'name' ? translations.contrName : translations.edrpouName}
              value={editingField === 'name' ? (editingSupplier?.name || '') : (editingSupplier?.ederpou_name || '')}
              onChange={(e) => setEditingSupplier({...editingSupplier, [editingField]: e.target.value})}
              fullWidth
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={editingSupplier?.status === 1}
                  onChange={(e) => setEditingSupplier({...editingSupplier, status: e.target.checked ? 1 : 0})}
                />
              }
              label={translations.activeConfig}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditDialog}>{translations.cancel}</Button>
          <Button onClick={handleSaveEdit} variant="contained">{translations.save}</Button>
        </DialogActions>
      </Dialog>

      {/* ===== Exclusion dialog ===== */}
      <Dialog open={exclusionDialogOpen} onClose={handleCloseExclusionDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          {editingExclusion ? 'Редагувати правило' : 'Нове правило виключення'}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Назва правила"
              value={newExclusion.name}
              onChange={(e) => setNewExclusion({ ...newExclusion, name: e.target.value })}
              fullWidth required
            />
            <TextField
              label="Опис (необов'язково)"
              value={newExclusion.description}
              onChange={(e) => setNewExclusion({ ...newExclusion, description: e.target.value })}
              fullWidth multiline rows={2}
            />
            <FormControl fullWidth>
              <InputLabel>Режим співпадіння</InputLabel>
              <Select
                value={newExclusion.matchMode}
                label="Режим співпадіння"
                onChange={(e) => setNewExclusion({ ...newExclusion, matchMode: e.target.value })}
              >
                <MenuItem value="startsWith">Починається з</MenuItem>
                <MenuItem value="contains">Містить</MenuItem>
                <MenuItem value="equals">Точна рівність</MenuItem>
                <MenuItem value="regex">Регулярний вираз</MenuItem>
              </Select>
            </FormControl>

            <FormControlLabel
              control={
                <Checkbox
                  checked={newExclusion.caseSensitive}
                  onChange={(e) => setNewExclusion({ ...newExclusion, caseSensitive: e.target.checked })}
                />
              }
              label="Враховувати регістр"
            />

            <Typography variant="subtitle2">Ключові слова / фрази</Typography>
            {newExclusion.keywords.map((kw, index) => (
              <Box key={index} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <TextField
                  value={kw}
                  onChange={(e) => handleExclusionKeywordChange(index, e.target.value)}
                  fullWidth
                  placeholder="Наприклад: 101 АКЦИЗНИЙ ПОДАТОК"
                />
                {index === newExclusion.keywords.length - 1 ? (
                  <IconButton onClick={handleAddExclusionKeyword} color="primary"><AddIcon /></IconButton>
                ) : (
                  <IconButton onClick={() => handleRemoveExclusionKeyword(index)} color="error"><DeleteIcon /></IconButton>
                )}
              </Box>
            ))}

            <FormControlLabel
              control={
                <Checkbox
                  checked={newExclusion.status === '1'}
                  onChange={(e) => setNewExclusion({ ...newExclusion, status: e.target.checked ? '1' : '0' })}
                />
              }
              label="Активне"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseExclusionDialog}>{translations?.cancel || 'Скасувати'}</Button>
          <Button onClick={handleSaveExclusion} variant="contained">{translations?.save || 'Зберегти'}</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SuppliersPage;